import React, { useEffect, useState } from 'react';
import { Grid, Box, Hidden } from '@material-ui/core';
import './Homepage2.css';
import { useHistory } from 'react-router-dom';
import arya from '../../assets/images/254381.jpg';
import mb from '../../assets/images/mb.jpeg';
import TitleText from '../../components/reusableComponents/TitleText';
import LoginB2B from '../../form/LoginB2B';
import RegisterAgentModal from '../../components/reusableComponents/RegisterAgentModal';
import Footer from './Footer';
const B2BHome = () => {
	const history = useHistory();
	const [tabvalue, setValue] = React.useState(0);
	return (
		<>
			<nav
				className='navbar'
				style={{
					background: 'white',
					padding: 0,
					paddingTop: 8,
					position: 'fixed',
					width: '100%',
					zIndex: 999,
				}}>
				<div className='container flex'>
					<Box display={'flex'} style={{ alignItems: 'center' }}>
						<img
							style={{
								cursor: 'pointer',
								height: 45,
								// height: matches ? 30 : 45,
							}}
							src={mb}
							onClick={() => history.push('/')}></img>
						<Box>
							<span
								style={{
									// fontFamily: 'Lato',
									fontSize: '23px',
									fontWeight: 'bold',
									color: 'rgb(114, 28, 129)',
								}}>
								Musafir Bazar
							</span>
							<p
								style={{
									// fontFamily: 'Lato',
									fontSize: 12,
								}}>
								A unit of R Arya Aviation India Pvt Ltd
							</p>
						</Box>
					</Box>

					<Hidden only={['xs', 'sm']}>
						<Box display='flex' alignItems='center'>
							<TitleText textStyle={{ fontSize: 18 }}>
								24x7 Agent Helpline
							</TitleText>
							<i
								class='fas fa-phone'
								style={{
									transform: 'rotate(90deg)',
									color: '#ef3339',
									fontSize: '20px',
									marginLeft: 20,
								}}></i>
							<Box onClick={() => (window.location = 'tel:887-777-3388')}>
								<TitleText
									textStyle={{
										marginLeft: 10,
										fontSize: 18,
										cursor: 'pointer',
									}}>
									+91 887-777-3388
								</TitleText>
							</Box>
							<i
								class='fa fa-envelope'
								style={{
									color: '#ef3339',
									fontSize: '20px',
									marginLeft: 20,
								}}></i>
							<Box>
								<TitleText
									textStyle={{
										marginLeft: 10,
										fontSize: 18,
										cursor: 'pointer',
									}}>
									info@musafirbazar.com
								</TitleText>
							</Box>
						</Box>
					</Hidden>
				</div>
			</nav>
			<header
				className='flex'
				style={{
					backgroundImage: `url(${arya})`,
					zIndex: 0,
					transition: 'background-image 300ms ease-in 200ms',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
					backgroundPosition: 'center center',
					backgroundAttachment: 'fixed',
					height: tabvalue === 1 ? '1200px' : '800px',
				}}>
				<Grid container>
					<Grid item xs={12} md={6}>
						{/* <LoginForm/> */}
					</Grid>
					<Grid item xs={12} md={6}>
						<LoginB2B tabvalue={tabvalue} setValue={setValue} />
					</Grid>
				</Grid>
			</header>
			<Footer />
			<RegisterAgentModal />
		</>
	);
};

export default B2BHome;
